import { css, cx } from '@/styled-system/css';

export const carouselWrapperCX = (options: { isCarouselCard?: boolean }) =>
  css({
    bgColor: 'hpxGrey400',
    height: '224px',
    overflow: 'hidden',
    position: 'relative',
    width: {
      base: '100%',
      listingCardWidth: options?.isCarouselCard ? '298px' : '402px',
    },
    borderTopLeftRadius: '8px',
    borderTopRightRadius: '8px',
    borderBottomLeftRadius: '0px',
    borderBottomRightRadius: '0px',
  });

export const carouselContentCX = css({
  display: 'block',
  width: '100%',
  height: '100%',
  transitionProperty: 'transform',
  transitionDuration: '0.3s',
  whiteSpace: 'nowrap',
  textDecoration: 'none',
  color: 'inherit',
  outlineWidth: 0,
});

export const touchTargetCX = css({
  alignItems: 'center',
  backgroundColor: 'transparent',
  cursor: 'pointer',
  display: 'flex',
  height: '48px',
  justifyContent: 'center',
  position: 'absolute',
  top: '110px',
  width: '48px',
  zIndex: '1',
});

export const prevTouchTargetCX = cx(
  touchTargetCX,
  css({
    left: '4px',
  }),
);

export const nextTouchTargetCX = cx(
  touchTargetCX,
  css({
    right: '4px',
  }),
);

export const getSlideButtonCX = (isVisible: boolean) =>
  css({
    alignItems: 'center',
    animation: 'fadingIn',
    borderRadius: '50%',
    cursor: 'pointer',
    display: 'flex',
    height: '32px',
    justifyContent: 'center',
    position: 'absolute',
    top: '118px',
    width: '32px',
    zIndex: '1',
    bgColor: isVisible ? 'white' : '',
    boxShadow: isVisible ? '0px 2px 4px rgba(0, 0, 0, 0.3)' : '',
  });

export const getPrevImageButtonCX = (isVisible: boolean) =>
  cx(
    getSlideButtonCX(isVisible),
    css({
      left: '8px',
    }),
  );

export const getNextImageButtonCX = (isVisible: boolean) =>
  cx(
    getSlideButtonCX(isVisible),
    css({
      right: '8px',
    }),
  );

export const getArrowImageCX = (isVisible: boolean) =>
  css({
    display: isVisible ? 'inline' : 'none',
  });

export const heroImageCX = (options?: { isCarouselCard?: boolean }) =>
  css({
    bgColor: 'hpxGrey400',
    height: options?.isCarouselCard ? '224px' : '268px',
    objectFit: 'cover',
    width: options?.isCarouselCard ? '298px' : '402px',
  });

export const dotWrapperCX = css({
  position: 'absolute',
  bottom: '8px',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  zIndex: '1',
});
